// utils/tableUtils.js

export const hasAnyRole = (matchRoles = []) => {
  try {
    const userRoles = localStorage.getItem("roles") || "";
    const userRolesArray = userRoles.split(",");

    return userRolesArray.some((role) => matchRoles.includes(role));
  } catch {
    return false;
  }
};

export const filterTableColumns = ({
  headList,
  removeIfNoPermission = [],
  roleConfig = {},
}) => {
  let filtered = [...headList];

  // Permission-based filtering
  removeIfNoPermission.forEach(({ key, condition }) => {
    if (!condition) {
      filtered = filtered.filter((col) => col.title !== key);
    }
  });

  // Role-based filtering
  Object.entries(roleConfig).forEach(([column, roles]) => {
    const hasRole = hasAnyRole(roles);
    if (!hasRole) {
      filtered = filtered.filter((col) => col.title !== column);
    }
  });

  return filtered;
};